module.exports = __webpack_public_path__ + "img/tooltip_01-VALLONE_MURALE_ENSEMBLE_C.dad6bd52.jpg";